module.exports = __webpack_public_path__ + "static/media/winner.b9b754a1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/winner.mp3
// module id = 1651
// module chunks = 0